"use client";

import {useEffect} from "react";
import {
	COURSE_SECTION_IDS,
	scrollToCourseSection,
	type CourseSectionId,
} from "./scrollToCourseSection";

const SCROLLABLE_SECTION_IDS = new Set<string>(
	Object.values(COURSE_SECTION_IDS)
);

function isCourseSectionHash(hash: string): hash is CourseSectionId {
	return SCROLLABLE_SECTION_IDS.has(hash);
}

/**
 * On load, scroll course-page hash links (#info, #formats, #sequence, #cta)
 * using the same offset logic as in-flow auto-scroll after modality/part
 * selection.
 */
export function CourseSectionHashScroll() {
	useEffect(() => {
		const hash = window.location.hash.replace(/^#/, "");
		if (!isCourseSectionHash(hash)) {
			return;
		}

		scrollToCourseSection(hash);
	}, []);

	return null;
}
